import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { PageView, Button } from '@justgiving/react-tracking';
import Modal from '@justgiving/modal';
import CopyToClipboard from '@justgiving/copy-to-clipboard';
import { IInviteMessage } from './InviteMembersModal.d';
import WhatsAppButton from './WhatsAppButton';
import MessengerButton from './MessengerButton';
import EmailButton from './EmailButton';
import { withTrack } from '../../utils';

export const InviteMembersModal = ({
  shareMessage,
  shareHeader,
  shareURL,
  onCloseModal,
  fbAppId,
  isModalOpen,
  track,
}: IInviteMessage) => {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  function onCopy() {
    setCopiedToClipboard(true);
    track({
      action_name: 'click',
      subtype: 'invite',
      event: 'click',
      event_value: 'copy link',
      page_section: 'invite team members',
    });
  }

  return (
    <PageView
      trackingData={{
        subtype: 'page creation',
        event_value: 'invite team members',
        page_section: 'invite team members',
      }}
    >
      <Modal isOpen={isModalOpen} onRequestClose={onCloseModal}>
        <h1
          className="jg-h1 jg-space-mtmd jg-space-mblg container--heading"
          data-qa="invite-members-modal"
        >
          <Trans i18nKey="content.invitemembersmodal.heading" />
        </h1>
        <WhatsAppButton shareMessage={`${shareMessage}${shareURL}`} />
        <MessengerButton shareURL={shareURL} fbAppId={fbAppId} />
        <EmailButton
          shareMessage={`${shareMessage}${shareURL}`}
          shareHeader={`${shareHeader}`}
        />
        <CopyToClipboard
          text={shareURL}
          copyMessage={
            <Trans i18nKey="share.button.copytoclipboard.copylink" />
          }
          copiedMessage={
            <Trans i18nKey="share.button.copytoclipboard.linkcopied" />
          }
          onCopy={onCopy}
          copied={copiedToClipboard}
        />
        <div className="jg-space-mlsm jg-space-mrsm jg-text--center jg-space-mtms">
          <Button
            type="button"
            data-qa="do-this-later-link"
            onClick={onCloseModal}
            className="jg-btn--invisible jg-text--link"
            trackingData={{
              action_name: 'link click',
              subtype: 'hyperlink',
              event: 'link click',
              event_value: 'ill do this later',
              page_section: 'invite team members',
            }}
          >
            <Trans i18nKey="global.link.dothislater" />
          </Button>
        </div>
      </Modal>
    </PageView>
  );
};

export default withTrack(InviteMembersModal);
